import { render, staticRenderFns } from "./SoundOnIcon.vue?vue&type=template&id=71c85fae&"
import script from "./SoundOnIcon.vue?vue&type=script&lang=js&"
export * from "./SoundOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports